import { render, staticRenderFns } from "./WelcomeMessage.vue?vue&type=template&id=732bc905&"
import script from "./WelcomeMessage.vue?vue&type=script&lang=js&"
export * from "./WelcomeMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('732bc905')) {
      api.createRecord('732bc905', component.options)
    } else {
      api.reload('732bc905', component.options)
    }
    module.hot.accept("./WelcomeMessage.vue?vue&type=template&id=732bc905&", function () {
      api.rerender('732bc905', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/configuration/WelcomeMessage.vue"
export default component.exports